import { useEffect, useState } from "react"
import { useApi } from "utils"
import { ListDataType } from "../../types"

type FilterType = {
    period_type: number,
    month: number,
    year: number,
    date: string
}

export const useDataAsset = ({ period_type, month, year }: FilterType) => {
    const api = useApi()
    const [data, setData] = useState<ListDataType[]>([])
    const [isLoading, setLoading] = useState(true)

    const fetching = () => {
        api.get(`/assetdepre/data_asset`, {
            params: {
                period_type,
                method: 1,
                month,
                year
            }
        })
            .then((res) => setData(res.data.payload))
            .catch(() => setData([]))
            .finally(() => setLoading(false))
    }

    const refetch = () => fetching()

    useEffect(() => {
        fetching()

        return () => {
            setData([])
            setLoading(true)
        }

        // eslint-disable-next-line
    }, [period_type, month, year])

    return { data, isLoading, refetch }
}
